import {
  GET_PROGRAM_PROFILE,
  RESET_PROGRAM_PROFILE,
  PROGRAM_PROFILE_LOADING_STATE,
  START_LOADING_PROGRAM,
  ERROR_LOADING_PROGRAM,
  STOP_LOADING_PROGRAM,
} from "./action-types";
import { Dispatch } from "redux";
import apiLibrary from "services/api";
import { Toasts } from "view/components/Toasts";
export const fetchProgramProfileAction =
  (programId: string) => async (dispatch: Dispatch, getState: any) => {
    dispatch(loadingProgramProfile());
    dispatch({ type: START_LOADING_PROGRAM });
    try {
      const { data } = await apiLibrary.Programs.getProgramProfile(programId);

      dispatch({
        type: GET_PROGRAM_PROFILE,
        payload: data,
      });
    } catch (error: any) {
      const errorMsg = error?.response?.data?.message ?? error?.message;
      Toasts.error(errorMsg);
      dispatch({ type: RESET_PROGRAM_PROFILE });
      dispatch({ type: ERROR_LOADING_PROGRAM });
      window.location.href = "/programs/list";
    } finally {
      dispatch({ type: STOP_LOADING_PROGRAM });
    }
  };
export const resetProgramProfileAction = () => {
  return {
    type: RESET_PROGRAM_PROFILE,
  };
};

export const loadingProgramProfile = () => {
  return {
    type: PROGRAM_PROFILE_LOADING_STATE,
  };
};
